import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
export const GET_LIST_MEMBERSHIPS = registerQuery({
  fieldName: 'listMemberships',
  args: ['portalId', 'objectTypeId', 'objectId'],
  fetcher({
    portalId,
    objectTypeId,
    objectId
  }) {
    return HttpClient.get(`inbounddb-lists-membership/v1/object-memberships/all/${objectTypeId}/${objectId}/historical/audit`, {
      query: {
        portalId
      }
    }).then(resp => resp.map(datum => datum.objectListMembership));
  }
});
export const GET_LIST_MEMBERSHIPS_BY_LIST = registerQuery({
  fieldName: 'listMembershipsByList',
  args: ['portalId', 'objectTypeId', 'objectId', 'listId'],
  fetcher({
    portalId,
    objectTypeId,
    objectId,
    listId
  }) {
    return HttpClient.get(`inbounddb-lists-membership/v1/object-memberships/all/${objectTypeId}/${objectId}/historical/${listId}`, {
      query: {
        portalId
      }
    }).then(resp => resp.allListMemberships);
  }
});
export const GET_LIST_DEFINITIONS = registerQuery({
  fieldName: 'listDefinitions',
  args: ['portalId', 'listIds'],
  fetcher({
    portalId,
    listIds
  }) {
    return HttpClient.get('inbounddb-lists/v1/lists', {
      query: {
        portalId,
        listIds
      }
    });
  }
});
export const GET_LIST_REFERENCES = registerQuery({
  fieldName: 'listReferences',
  args: ['portalId', 'listId'],
  fetcher({
    portalId,
    listId
  }) {
    return HttpClient.get(`inbounddb-lists/v1/list-references/${listId}`, {
      query: {
        portalId
      }
    });
  }
});